import React from "react";
import {
  Switch,
  Link,
  Route,
  Redirect,
  useParams,
  useHistory,
} from "react-router-dom";

import IconButton from "@material-ui/core/IconButton";
import Fab from "@material-ui/core/Fab";
import PeopleIcon from "@material-ui/icons/People";
import PersonIcon from "@material-ui/icons/Person";
import FlagIcon from "@material-ui/icons/Flag";

import { MEPView } from "./MEP";
import { GroupView } from "./Group";
import { CountryView } from "./Country";
import { Button, Typography } from "@material-ui/core";

import Logo from "../Logo/LOGO.png";

export const Home = () => {
  const params = useParams<{ id: string }>();
  const history = useHistory();

  return (
    <div>
      <section className="top-area">
        <div style={{ textAlign: "center", paddingTop: "40px" }}>
          <img
            style={{ width: "100px", marginBottom: "20px" }}
            src={Logo}
            alt="Next Generation Democracy Logo"
          />
          <Typography variant="h5">Future Readiness Index</Typography>
        </div>

        <div className="view-selector-area">
          {[
            {
              state: "group",
              button: (active: boolean) => (
                <>
                  <Fab
                    size={active ? "large" : "small"}
                    color={active ? "secondary" : "default"}
                  >
                    <PeopleIcon fontSize={active ? "large" : "small"} />
                  </Fab>
                </>
              ),
            },
            {
              state: "mep",
              button: (active: boolean) => (
                <Fab
                  size={active ? "large" : "small"}
                  color={active ? "secondary" : "default"}
                >
                  <PersonIcon fontSize={active ? "large" : "small"} />
                </Fab>
              ),
            },
            {
              state: "country",
              button: (active: boolean) => (
                <Fab
                  size={active ? "large" : "small"}
                  color={active ? "secondary" : "default"}
                >
                  <FlagIcon fontSize={active ? "large" : "small"} />
                </Fab>
              ),
            },
          ].map((mode) => (
            <Link
              to={`/${mode.state}`}
              style={{ textDecoration: "none", color: "gray" }}
            >
              <IconButton>
                {mode.button(mode.state === params["id"])}
              </IconButton>
              <div
                style={{
                  textAlign: "center",
                }}
              >
                <Typography variant="caption">
                  {mode.state.toUpperCase()}
                </Typography>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <section>
        <Switch>
          <Route path="/mep" exact component={MEPView} />
          <Route path="/country" exact component={CountryView} />
          <Route path="/group" exact component={GroupView} />
          <Redirect to="/mep" />
        </Switch>
      </section>
    </div>
  );
};
